export const noteTypes = {
  NOTE: "note",
  TASK: "task",
  ALERT: "alert",
  DISCHARGE: "discharge",
} as const;

export type NoteType = (typeof noteTypes)[keyof typeof noteTypes];
